module.exports = __webpack_public_path__ + "static/media/completed.b04536f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/completed.png
// module id = 257
// module chunks = 0